// import Vue from 'vue'

import CardH1 from './CardH1'
import CardH2L from './CardH2L'
import CardH2R from './CardH2R'

import CardV2B from './CardV2B'
import CardV2T from './CardV2T'
import CardV3B from './CardV3B'
import CardV3T from './CardV3T'
import CardV4B from './CardV4B'
import CardV4T from './CardV4T'
import CardV5 from './CardV5'

import CardZ1 from './CardZ1'
import CardZ2 from './CardZ2'
import CardZ2L from './CardZ2L'
import CardZ2P from './CardZ2P'
import CardZ3 from './CardZ3'
import CardZ3S from './CardZ3S'
import CardZ4 from './CardZ4'

Vue.component(CardH1.name, CardH1)
Vue.component(CardH2L.name, CardH2L)
Vue.component(CardH2R.name, CardH2R)

Vue.component(CardV2B.name, CardV2B)
Vue.component(CardV2T.name, CardV2T)
Vue.component(CardV3B.name, CardV3B)
Vue.component(CardV3T.name, CardV3T)
Vue.component(CardV4B.name, CardV4B)
Vue.component(CardV4T.name, CardV4T)
Vue.component(CardV5.name, CardV5)

Vue.component(CardZ1.name, CardZ1)
Vue.component(CardZ2.name, CardZ2)
Vue.component(CardZ2L.name, CardZ2L)
Vue.component(CardZ2P.name, CardZ2P)
Vue.component(CardZ3.name, CardZ3)
Vue.component(CardZ3S.name, CardZ3S)
Vue.component(CardZ4.name, CardZ4)

module.export = {
  CardH1,
  CardH2L,
  CardH2R,
  CardV2B,
  CardV2T,
  CardV3B,
  CardV3T,
  CardV4B,
  CardV4T,
  CardV5,
  CardZ1,
  CardZ2,
  CardZ2L,
  CardZ2P,
  CardZ3,
  CardZ3S,
  CardZ4,
}




// WEBPACK FOOTER //
// ./src/page/cardpage/card/index.js